/* eslint-disable indent */
export default class Toggle {
  constructor(elements) {
    this.triggers = elements;
    this.setDOMReferences();
  }

  setDOMReferences() {
    for (let i = 0; i < this.triggers.length; i++) {
      const element = this.triggers[i];
      element.addEventListener('click', () => {
        /* Check if a trigger shou */
        if (this.triggers[i].hasAttribute('data-set-passive-id')) {
          this.update(this.triggers[i].dataset.setPassiveId, 'passive');
        }

        const id = element.dataset.toggleId;
        let { state } = element.dataset;
        state = (state === 'passive') ? 'active' : 'passive';
        this.update(id, state);
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  update(id, state) {
    const elements = document.querySelectorAll(`[data-toggle-id=${id}]`);
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      element.setAttribute('data-state', state);
    }
  }
}
